import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  Chip,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {},
  cardStripe: {
    position: 'relative',
  },
  avatar: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    transform: 'translate(20px, -30px)'
  },
  rightAlignedText: {
    marginLeft: 'auto',
  },
  chip: {
    width: 60,
  },
}));

function ClaimsCardSkeleon({ claim, className, ...rest }) {
  const classes = useStyles();

  return (
    <Card 
      className={clsx(classes.root, className)} 
      {...rest}
    >
      <CardHeader
        title={
          <Box display="flex" alignItems="center">
            <Skeleton variant="text" width={120} />
            <Box flexGrow={1} />
            <Skeleton variant="text" width={80} />
          </Box>
        }
      />
      <Skeleton 
        variant="rect"
        component="div"
        className={classes.cardStripe}
        height={60}
      />
      <Skeleton 
        className={classes.avatar}
        variant="circle"
        width={50}
        height={50}
      />
      <Box p={2}>
        <Box display="flex" alignItems="center">
          <Box className={classes.claimant}>
            <Skeleton width={100} />
          </Box>  
        </Box>
      </Box>

      <Box p={2}>
        <Grid
          className={classes.gridRow}
          alignItems="center"
          direction="row"
          container
          justifyContent="space-between"
        >
          <Grid item xs={5}>
            <Skeleton width={70} />
            <Skeleton width={40} />
          </Grid>
          <Grid item xs={5}>
            <Skeleton className={classes.rightAlignedText} width={70} />
            <Skeleton className={classes.rightAlignedText} width={40} />
          </Grid>
        </Grid>
      </Box>
      <Box p={2}>
        <Grid
          className={classes.gridRow}
          alignItems="center"
          container
          justifyContent="space-between"
          spacing={3}
        >
          <Grid item xs={5}>
            <Skeleton width={70} />
            <Skeleton width={40} />
          </Grid>
          <Grid item xs={5}>
            <Skeleton className={classes.rightAlignedText} width={70} />
            <Skeleton className={classes.rightAlignedText} width={40} />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box p={2} display="flex" alignItems="center">
        <Skeleton variant="rect" width={40} height={25} />
        <Skeleton 
          style={{marginLeft: 10}} 
          variant="rect" 
          width={40} 
          height={25} 
        />
        <Box flexGrow={1} />
        <Chip
          className={classes.chip} 
          label={claim.claimStatus} 
        />
      </Box>
    </Card>
  );
}

ClaimsCardSkeleon.propTypes = {
  className: PropTypes.string,
  claim: PropTypes.object.isRequired,
 
};

export default ClaimsCardSkeleon;
